import { FC } from 'react';

import { Box } from '@mui/material';

import { CloseIcon } from 'shared/assets/icons';

interface IProps {
  name: string;
  text?: string;
  color?: string;
  onRemove?: () => void;
}

export const SelectionItem: FC<IProps> = ({ name, text, color, onRemove }) => (
  <Box
    sx={{
      textAlign: 'left',
      direction: 'ltr'
    }}
    p={'18px 0'}
    display={'flex'}
    gap={'10px'}
    borderBottom='1px solid var(--mui-palette-messageParsing-selectionsDivider)'
    justifyContent={'space-between'}>
    <Box textTransform={'capitalize'} borderRadius={'100px'} p={'6px'}>
      {name}
    </Box>
    {text && (
      <Box
        borderRadius={'100px'}
        gap={'4px'}
        p={'6px 24px'}
        display={'flex'}
        alignItems={'center'}
        bgcolor={color}
        maxWidth={'calc(100% - 100px) !important'}
        sx={{ wordBreak: 'break-all', svg: { width: '100%', height: '100%' } }}>
        {text}
        <Box
          minWidth={'16px'}
          minHeight={'16px'}
          onClick={onRemove}
          sx={{
            cursor: 'pointer',
            '&.MuiBox-root': {
              maxWidth: '16px',
              maxHeight: '16px'
            }
          }}>
          <CloseIcon fontSize={'small'} />
        </Box>
      </Box>
    )}
  </Box>
);
